import { render } from "./MoneyAndUserInfo.vue?vue&type=template&id=0d132e7a&scoped=true&ts=true"
import script from "./MoneyAndUserInfo.vue?vue&type=script&lang=ts"
export * from "./MoneyAndUserInfo.vue?vue&type=script&lang=ts"

import "./MoneyAndUserInfo.vue?vue&type=style&index=0&id=0d132e7a&lang=scss&scoped=true"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d132e7a"]])

export default __exports__